import { rest } from 'msw';
import config from '@/lib/config/index';
import elearningJsonFile from './published-content/c62caed5-f224-4a63-bd19-d3df6550c30b/review/elearnings/5ea7bb0c-b64f-4b19-800f-2882d78d7725/1674519668701/elearning.json';
import quizJsonFile from './published-content/c62caed5-f224-4a63-bd19-d3df6550c30b/review/quizzes/5ea7bb0c-b64f-4b19-800f-2882d78d7725/1674519668701/quiz.json';
import helpJsonFile from './published-common-content/help.json';
import reviewersUsersFile from './reviewers/users.json';
import reviewersUsersFile2 from './reviewers/users2.json';
import capabilitiesFile from './auth/capabilities.json';
import elearningLibraryJsonFile from './elearning-library/elearning-library.json';
import navigationFile from './navigation/navigation.json';
import elearningCategoriesFile from './elearning-categories/elearningCategories.json';
import courseLibraryDownload from './elearning-library/course-library-download.json';

export const handlers = [
  rest.get(
    `${config.api.baseUrl}/v1/vocam/getVideoPreviewLink/*`,
    (req, res, ctx) => {
      // TODO: This is for the form
      const result =
        'https://elmo-vocam.akamaized.net/hls/au/ele/au_nhlp_ele_t01/master.m3u8?_b_=648&hdnea=st=1699843527~exp=1699844727~acl=/*~hmac=34bd2897a52f2de307a2072649fee210dadcc563f8f690f0e624113835ba4382';
      return res(ctx.status(200), ctx.text(result));
    },
  ),
  rest.get(`${config.api.baseUrl}/v1/vocam/getVideoLink/*`, (req, res, ctx) => {
    // TODO: This is for the player, we are using slideId
    const result =
      'https://elmo-vocam.akamaized.net/hls/au/ele/au_nhlp_ele_t01/master.m3u8?_b_=648&hdnea=st=1699843527~exp=1699844727~acl=/*~hmac=34bd2897a52f2de307a2072649fee210dadcc563f8f690f0e624113835ba4382';
    return res(ctx.status(200), ctx.text(result));
  }),
  rest.get(
    `${config.api.baseUrl}/oauth2-client/auth/check-token`,
    (req, res, ctx) => res(ctx.status(200), ctx.json({})),
  ),

  rest.get(
    `${config.api.baseUrl}/v1/elearning-library/check-download-completed/*`,
    async (req, res, ctx) => {
      const isSuccess = Math.random() * 10 < 7; // to emulate polling and not return false directly
      if (isSuccess) await new Promise((resolve) => setTimeout(resolve, 2000));
      return res(ctx.status(200), ctx.json(isSuccess));
    },
  ),

  rest.post(
    `${config.api.baseUrl}/v1/elearning-library/download`,
    async (req, res, ctx) => {
      /* Switch the responses to emulate success or error */
      const courseId = await req.json().then((value) => value.courseId);
      // const response2 = {
      //   statusCode: 202,
      //   // Course Id is not included in the actual response - including it here for local testing purposes
      //   message: `Download ${courseId} already in Progress`,
      // };

      const response = 'OK.';

      return res(ctx.status(201), ctx.text(response)); // success
      // return res(ctx.status(202), ctx.json(response2)); // error
    },
  ),

  rest.post(
    `${config.api.baseUrl}/api/v1/elearnings/publish`,
    (req, res, ctx) => {
      const result = {
        message: 'Some message from dynamo db',
        code: 'some code here',
        time: '2023-02-02T02:09:01.311Z',
        requestId: 'B3L69ELT5E6GVBSJJ8PLIU67ARVV4KQNSO5AEMVJF66Q9ASUAAJG',
        statusCode: 200,
        retryable: false,
        retryDelay: 36.61974509664062,
      };

      return res(ctx.status(200), ctx.json(result));
    },
  ),

  rest.post(`${config.api.baseUrl}/v1/elearnings/publish`, (req, res, ctx) => {
    const result = {
      message: 'Publish start: Some message from dynamo db on',
      code: 'some code here',
      time: '2023-02-02T02:09:01.311Z',
      requestId: 'B3L69ELT5E6GVBSJJ8PLIU67ARVV4KQNSO5AEMVJF66Q9ASUAAJG',
      statusCode: 200,
      retryable: false,
      retryDelay: 36.61974509664062,
    };

    return res(ctx.status(200), ctx.json(result));
  }),

  rest.get(
    `${config.api.baseUrl}/api/v1/elearnings/publish/result/*/*`,
    (req, res, ctx) => {
      const randomNumber = Math.random() * 10; // to emulate polling and not return false directly
      return res(ctx.status(200), ctx.json(randomNumber < 7));
    },
  ),

  rest.get(
    `${config.api.baseUrl}/v1/elearnings/publish/result/*/*`,
    (req, res, ctx) => {
      const randomNumber = Math.random() * 10; // to emulate polling and not return false directly
      return res(ctx.status(200), ctx.json(randomNumber < 7));
    },
  ),

  rest.get(`${config.api.baseUrl}/get-manifest`, (req, res, ctx) => {
    const result = {
      Item: {
        playerVersion: '1.0.0',
        quizIdentifier: '1673400199496',
        deleted: false,
        SK: 'c62caed5-f224-4a63-bd19-d3df6550c30b/2e372617-f9a4-40ac-a236-32e03689ee78/review',
        description:
          '<p>Health care workers have a responsibility to act if they know or suspect that someone in their care is being abused or neglected.</p>\r\n\r\n<p>This course has therefore been developed to help learners understand what they should do if they know or suspect that someone has been abused or neglected. It will also look at the common types of abuse and neglect and their indicators.</p>\r\n',
        PK: 'c62caed5-f224-4a63-bd19-d3df6550c30b',
        elearningIdentifier: '1673400199496',
        title: 'Abuse and Neglect(Copy)',
        elearningType: 'review',
        tenantIdentifier: 'coursebuilder.dev',
        updatedAt: '1/11/2023, 12:23:28 PM',
        tags: '',
      },
      $metadata: {
        totalRetryDelay: 0,
        requestId: 'PBE7FJ8TK3FDUUVBKTT0R2FM63VV4KQNSO5AEMVJF66Q9ASUAAJG',
        httpStatusCode: 200,
        attempts: 1,
      },
    };

    return res(ctx.status(200), ctx.json(result));
  }),

  rest.get(
    `${config.api.baseUrl}/v1/signed-cookies/content/generate`,
    (req, res, ctx) => res(ctx.status(200), ctx.json({ message: 'success' })),
  ),

  rest.get(
    `${config.api.baseUrl}/v1/signed-cookies/generate`,
    (req, res, ctx) =>
      res(
        ctx.status(200),
        ctx.json({
          message: 'ok!',
          url: 'learningapi.s-ela.elmodev.com',
          corsDomain: 'learningapi.s-ela.elmodev.com',
          resources: [
            '/published-content-assets/c62caed5-f224-4a63-bd19-d3df6550c30b/review/elearnings/24458c9d-4876-4236-9b48-872bf2276f38/1670390187334/',
            '/published-content/c62caed5-f224-4a63-bd19-d3df6550c30b/review/elearnings/24458c9d-4876-4236-9b48-872bf2276f38/1670390187334/',
          ],
          signedCookie: [
            'CloudFront-Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cCo6Ly9sZWFybmluZ2FwaS5zLWVsYS5lbG1vZGV2LmNvbS9wdWJsaXNoZWQtY29udGVudC1hc3NldHMvYzYyY2FlZDUtZjIyNC00YTYzLWJkMTktZDNkZjY1NTBjMzBiL3Jldmlldy9lbGVhcm5pbmdzLzI0NDU4YzlkLTQ4NzYtNDIzNi05YjQ4LTg3MmJmMjI3NmYzOC8xNjcwMzkwMTg3MzM0LyoiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE2NzQyNjI5MjR9fX1dfQ__;Path=/published-content-assets/c62caed5-f224-4a63-bd19-d3df6550c30b/review/elearnings/24458c9d-4876-4236-9b48-872bf2276f38/1670390187334/;Secure;HttpOnly;SameSite=Lax',
            'CloudFront-Key-Pair-Id=K2SVV0OXA08PZZ;Path=/published-content-assets/c62caed5-f224-4a63-bd19-d3df6550c30b/review/elearnings/24458c9d-4876-4236-9b48-872bf2276f38/1670390187334/;Secure;HttpOnly;SameSite=Lax',
            'CloudFront-Signature=qGhe9udfCdWKbqQ1q3TtSN~bBhRgqnoZ~zeWVttAgOojmH8gIV4M-kAkv2iQWJruj3DbcqQETlASubCAMVG~uI0Gwj9bqHMqTVm37hDu5dvZeapeVHJJehWV45BDklLXKXfZt-dQCLRQFPrekF7DCMQsSfYGR5EyIRh4Zn0Z673LaNSAm350pXg~NMiuQEYd0jA-pWsdO6viKz1nzWDk1MtHSuTZmPQo5RveETGvGMSFXnPhi2dfbvhXi82S5m2LuNBsfwIpNOp-jhNYiCLHtK35cj7dz~hdZsGEVOF~-fqLVAnMcGKbGtcRNhittZH31n2GA4ZVAZ0UclSrMdrm-Q__;Path=/published-content-assets/c62caed5-f224-4a63-bd19-d3df6550c30b/review/elearnings/24458c9d-4876-4236-9b48-872bf2276f38/1670390187334/;Secure;HttpOnly;SameSite=Lax',
            'CloudFront-Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cCo6Ly9sZWFybmluZ2FwaS5zLWVsYS5lbG1vZGV2LmNvbS9wdWJsaXNoZWQtY29udGVudC9jNjJjYWVkNS1mMjI0LTRhNjMtYmQxOS1kM2RmNjU1MGMzMGIvcmV2aWV3L2VsZWFybmluZ3MvMjQ0NThjOWQtNDg3Ni00MjM2LTliNDgtODcyYmYyMjc2ZjM4LzE2NzAzOTAxODczMzQvKiIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTY3NDI2MjkyNH19fV19;Path=/published-content/c62caed5-f224-4a63-bd19-d3df6550c30b/review/elearnings/24458c9d-4876-4236-9b48-872bf2276f38/1670390187334/;Secure;HttpOnly;SameSite=Lax',
            'CloudFront-Key-Pair-Id=K2SVV0OXA08PZZ;Path=/published-content/c62caed5-f224-4a63-bd19-d3df6550c30b/review/elearnings/24458c9d-4876-4236-9b48-872bf2276f38/1670390187334/;Secure;HttpOnly;SameSite=Lax',
            'CloudFront-Signature=n5pBX96sqQPh4hdegwv9146zdX5-15v~42FKbZsxau03jPz3v7PHewXRZYtXFQhogVIYyAgBw1IKZgJiGNU43K6spY-3WvfJfvGXKMyvVAfHBphW7RxFRtyBCxHPAQ4cnl4DSNyCCMNDabx5~UOrzo0ZLxAmiG4fLxL8s9aEj1~aX2XJNt8hSdawdSGRzjtJg6Im2tyNXXKQ5SEp0i9reianCEklXA88O3jSVkAHT4PgpfL5hdm7s7N1IRGZvYgvVzkshDrAJYzBxERhzcs4ozYjeksluD-V8YfHa9ONmrnXEONnieKLiaHrenJEKvkpXNpHsW1rtUM2Tec~5TEqzA__;Path=/published-content/c62caed5-f224-4a63-bd19-d3df6550c30b/review/elearnings/24458c9d-4876-4236-9b48-872bf2276f38/1670390187334/;Secure;HttpOnly;SameSite=Lax',
          ],
        }),
      ),
  ),

  rest.get(
    `${config.api.baseUrl}/published-content/*/*/elearnings/*/*/elearning.json`,
    (req, res, ctx) => res(ctx.status(200), ctx.json(elearningJsonFile)),
  ),

  rest.get(
    `${config.api.baseUrl}/published-content/*/*/quizzes/*/*/quiz.json`,
    (req, res, ctx) => res(ctx.status(200), ctx.json(quizJsonFile)),
  ),

  rest.get(
    `${config.api.baseUrl}/published-common-content/help.json`,
    (req, res, ctx) => res(ctx.status(200), ctx.json(helpJsonFile)),
  ),

  rest.get(`${config.api.baseUrl}/v1/reviewers/users`, (req, res, ctx) => {
    const type = req.url.searchParams.get('type');
    const page = req.url.searchParams.get('page');
    const text = req.url.searchParams.get('text');
    if (type && page && text) {
      switch (page) {
        case '2':
          return res(ctx.delay(3000), ctx.json(reviewersUsersFile2));
        default:
          return res(ctx.delay(3000), ctx.json(reviewersUsersFile));
      }
    }
  }),

  rest.get(`${config.api.baseUrl}/v1/users/capabilities`, (req, res, ctx) =>
    res(ctx.status(200), ctx.json(capabilitiesFile)),
  ),

  rest.get(
    `${config.api.baseUrl}/v1/elearning-library/list*`,
    (req, res, ctx) => res(ctx.status(200), ctx.json(elearningLibraryJsonFile)),
  ),

  rest.get(
    `${config.api.baseUrl}/v1/elearning-library/videos*`,
    (req, res, ctx) => res(ctx.status(200), ctx.json(elearningLibraryJsonFile)),
  ),

  rest.get(`${config.api.baseUrl}/bff/navigation`, (req, res, ctx) =>
    res(ctx.status(200), ctx.json(navigationFile)),
  ),

  rest.get(`${config.api.baseUrl}/bff/user`, (req, res, ctx) => {
    const result = {
      loginExpiry: 1692084208,
      authenticated: true,
      oauthHost: 'ela1.elmodev.com',
      user: {},
    };

    return res(ctx.status(200), ctx.json(result));
  }),

  rest.get(
    `${config.api.baseUrl}/v1/elearning-categories/list`,
    (req, res, ctx) => res(ctx.status(200), ctx.json(elearningCategoriesFile)),
  ),
  rest.post(
    `${config.api.baseUrl}/v1/elearning-library/course-library/*/download`,
    (req, res, ctx) =>
      // Uncomment the line below to simulate failure
      // res(
      //   ctx.delay(1000),
      //   ctx.status(400),
      //   ctx.json({ message: 'Download failed: Course not available' }),
      // ),

      // Success response
      res(ctx.delay(2000), ctx.status(201), ctx.json(courseLibraryDownload)),
  ),
  rest.get(
    `${config.api.baseUrl}/v1/elearning-categories/list-allowed-categories`,
    (req, res, ctx) => res(ctx.status(200), ctx.json(elearningCategoriesFile)),
  ),
  rest.get(
    `${config.api.baseUrl}/anon/v1/scorm/signed-cookies/generate`,
    (req, res, ctx) =>
      res(
        ctx.status(200),
        ctx.json({
          message: 'success',
          elearningId: 'xxx',
          identifier: 'xxxx',
          tenantId: 'xxxxxx',
          resourceSignature: {
            Policy: 'mock-policy',
            Signature: 'mock-signature',
            'Key-Pair-Id': 'mock-key-pair-id',
          },
        }),
      ),
  ),

  rest.get(
    `${config.api.baseUrl}/anon/v1/breathe/:tenantId/:elearningId/launch`,
    (req, res, ctx) => {
      const { tenantId, elearningId } = req.params;
      return res(
        ctx.status(200),
        ctx.json({
          tenantId,
          elearningId,
          identifier: '1674519668701',
          uid: 'mock-user-id',
          mid: 'mock-module-id',
          cid: 'mock-company-id',
          resourceSignature: {
            Policy: 'mock-policy',
            Signature: 'mock-signature',
            'Key-Pair-Id': 'mock-key-pair-id',
          },
        }),
      );
    },
  ),

  rest.post(
    `${config.api.baseUrl}/anon/v1/breathe/:tenantId/:elearningId/complete`,
    (req, res, ctx) =>
      res(
        ctx.delay(500),
        ctx.status(200),
        ctx.json({ message: 'Completion recorded successfully' }),
      ),
  ),
];
